export { default } from "./NotificationDetailModal";
